import ImageButtonImpl from './image-button.js';
import MojitoCore from 'mojito/core';
import { omit } from 'mojito/utils';
import { propTypes as buttonPropTypes } from 'presentation/components/button/index.js';
import PropTypes from 'prop-types';

const updatedButtonPropTypes = omit(buttonPropTypes, ['children']);
const UIView = MojitoCore.Presentation.UIView;

/**
 * A component that displays an image {@link Mojito.Presentation.Components.Image} within a button {@link Mojito.Presentation.Components.Button.component}. This component does not accept children.
 *
 * @class ImageButton
 * @memberof Mojito.Presentation.Components
 */

/**
 * `ImageButton` component prop types.
 *
 * {@link Mojito.Presentation.Components.Button.component.propTypes} Inherits the same propTypes as the Button component, excluding 'children'.
 *
 * @property {string} [label] - The label to be displayed for the ImageButton.
 * @property {string} [alt] - The 'alt' attribute specifies an alternate text for an image, if the image cannot be displayed.
 *
 * @memberof Mojito.Presentation.Components.ImageButton
 */
const propTypes = {
    ...updatedButtonPropTypes,
    label: PropTypes.string,
    alt: PropTypes.string,
};

const defaultProps = {
    alt: '',
};

export default UIView('ImageButton', ImageButtonImpl, propTypes, defaultProps);
